import { jsPDF } from "jspdf";
import { Hora } from "../Fecha";
import { firmaSubarrendatario, identificacionSubarrendatario, nombreParaArchivo } from "./ParteContratante";

export const Contrato30diasProvidencia = (datos, img) => {
	let { nombre, rut, fecha, correo, telefono } = datos;

	if (fecha === "hoy") {
		fecha = Hora();
	}
	const doc = new jsPDF();
	doc.setFont("arial");
	doc.setFontSize(20);
	doc.text("CONTRATO DE SUBARRIENDO PROVIDENCIA", 100, 25, { align: "center" });
	doc.line(20, 26, 183, 26);
	doc.setFontSize(12);
	var text1 = `En Santiago de Chile, a ${fecha}, entre Asesorias e Inversiones DN SpA, Rut 77.526.796-8, representada legalmente por Rodrigo Andres Araya Montalvan, Rut 15.380.582-2, domiciliado en Av. Nueva Providencia 1945, oficina 807, Comuna de Providencia, como “SUB ARRENDADOR", y, don(a) ${identificacionSubarrendatario(datos)}, como el “SUB ARRENDATARIO” quienes han convenido celebrar el siguiente CONTRATO DE SUBARRENDAMIENTO DE OFICINA VIRTUAL que se regirá por las cláusulas siguientes, y en silencio de ellas, por las disposiciones del Código Civil.`;
	var splitTitle1 = doc.splitTextToSize(text1, 190);
	doc.text(10, 40, splitTitle1);
	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("1° PROPIEDAD", 10, 77);
	doc.line(10, 78, 41, 78);
	doc.setFontSize(12);
	var text2 =
	    "El SUB ARRENDADOR, se encuentra autorizado a sub arrendar parte de la oficina N° 807, en Avenida Nueva Providencia 1945, de la Comuna de Providencia. Por el presente instrumento, el SUB ARRENDADOR, entrega en subarriendo solo para fines tributarios y comerciales, sin atención de público ni uso presencial alguno.";
	var splitTitle2 = doc.splitTextToSize(text2, 190);
	doc.text(10, 85, splitTitle2);
	doc.setFont("arial", "normal");
	doc.setFontSize(12);
	var text3 = `EL SUBARRENDATARIO, declara que los espacios mencionados tendrán como destino Oficina
Virtual, quedando expresamente prohibido introducir en la propiedad material inflamables, explosivo,
corrosivo o de cualquier índole que pudiera causarle daño o deterioro, siendo de su exclusiva responsabilidad
todo perjuicio a la propiedad o a terceros provocados por tales circunstancias.
El espacio se arrienda en el estado en que se encuentra, el que es conocido por el SUBARRENDATARIO.
Se comprenden los muebles, artefactos eléctricos, y todas las especies incorporadas al inmueble que forman un
solo cuerpo con él, de propiedad absoluta del “SUB ARRENDADOR”, por lo que no podrá efectuar mejoras o
modificaciones en las instalaciones, así como también no podrá instalar muebles, o cualquier artículo que
cambie la actual fisionomía de los espacios.`;
	var splitTitle3 = doc.splitTextToSize(text3, 190);
	doc.text(10, 106, splitTitle3);

	doc.setFont("arial", "bold");
	doc.text(
		"Señalar que el subarriendo solo será para EFECTOS TRIBUTARIOS Y COMERCIALES (Oficina Virtual).",
		10,
		155
	);
	doc.setFont("arial", "normal");
	doc.text("Forman parte de los servicios ofrecidos, los siguientes:", 10, 162);
	var text6 =
		"1). Dirección Tributaria: Se entiende dirección tributaria, ya que el cliente podrá utilizar la dirección individualizada en la primera clausula, para efectuar el inicio de actividades, cambio de domicilio ante el Servicio de Impuestos Internos (SII), para obtener así el Rut de su empresa, o para timbrar documentos que se refieran a su giro (facturas exentas, con IVA, boletas, etc.).";
	var splitTitle6 = doc.splitTextToSize(text6, 185);
	doc.text(20, 169, splitTitle6);
	var text7 =
		"2). Dirección Comercial: Se entiende dirección comercial, ya que el cliente podrá obtener su patente municipal.";
	var splitTitle7 = doc.splitTextToSize(text7, 185);
	doc.text(20, 190, splitTitle7);
	var text8 =
		"3). Recepción de correspondencia: Recepción de correspondencia: Esta prestación consiste en recibir la correspondencia del cliente (cartas y sobres), la que se guardará en una carpeta personal, dándosele aviso mediante correo electrónico para su posterior retiro. La empresa no se hace responsable del contenido y el deterioro de la correspondencia y/o encomienda, si así fuera el caso. De recibirse encomiendas de dimensiones por sobre una carta y/o sobre, se aplicará lo del artículo 4.";
	var splitTitle8 = doc.splitTextToSize(text8, 185);
	doc.text(20, 200, splitTitle8);	
	var text9 =
		"Sin perjuicio de lo anterior, queda expresamente prohibido al cliente utilizar el domicilio con otro propósito que no sea el descrito anteriormente, es decir, solo como dirección tributaria y/o comercial. En consecuencia, el domicilio de la oficina NO podrá ser utilizado de ninguna manera para la obtención de créditos bancarios, financieros y/o comerciales, o de cualquier otra índole.";
	var splitTitle9 = doc.splitTextToSize(text9, 185);
	doc.text(10, 230, splitTitle9);
	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("2° RENTA", 10, 255);
	doc.line(10, 256, 30, 256);
	doc.setFont("arial", "normal");
	var text10 =
		`Las partes fijan la renta mensual de sub arriendo por la oficina en $11.990 (once mil novecientos noventa pesos) la que deberá ser pagada anticipadamente entre los días 1 y 5 De cada mes en la recepción ubicada en el interior de la oficina, mediante transferencia bancaria o dinero efectivo.
La renta se reajustará según el IPC (Índice de precios del consumidor) acumulado del año, al momento en que se tenga que renovar el contrato.	`;
	var splitTitle10 = doc.splitTextToSize(text10, 190);
	doc.text(10, 262, splitTitle10);

	doc.addPage();
	doc.setFontSize(12);
	var text1=`Si el pago se realiza via transferencia o depósito, deberán ser realizados a la siguiente cuenta:

	BANCO: BANCO ESTADO
	Nombre Empresa: ASESORIAS E INVERSIONES DN SpA
	Rut: 77.526.796-8
	Tipo de Cuenta: Chequera electrónica // cuenta vista
	Número de cuenta: 90270930912
	Correo: pagos@denegocios.cl`;
	var splitTitle1 = doc.splitTextToSize(text1, 190);
	doc.text(10, 10, splitTitle1);

	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("3° PLAZO", 10, 52);
	doc.line(10, 53, 30, 53);
	doc.setFont("arial", "normal");
	var text2 = `El presente contrato empezó a regir el día ${fecha} y durará 1 mes de corrido. No obstante lo anteriormente señalado, este contrato se renovará sucesiva y automáticamente en períodos iguales al contratado, si ninguna de las partes da aviso a la otra con a lo menos 15 días de anticipación a la fecha de su vencimiento, por medio escrito, su deseo de poner término al presente contrato, e informando término de giro o cambio de domicilio ante Servicio de Impuestos Internos.

Se deja constancia que este contrato si bien entra en rigor en la fecha indicada, el pago correspondiente
comenzará a partir de los 30 días desde la fecha de firma. Es decir, el cliente tendrá 30 días desde la fecha de
firma y de corrido, libres de todo pago`;
	var splitTitle2 = doc.splitTextToSize(text2, 190);
	doc.text(10, 58, splitTitle2);
	doc.setFont("arial", "bold");
	var text3 =
		"El Cliente puede rescindir contrato antes de lo anteriormente estipulado, es decir el cliente podrá dejar el contrato de arriendo antes del plazo de 2 meses. Para ello deberá dar aviso a través de correo a contacto@denegocios.cl y/o a soporte@denegocios.cl de que ya no utilizará nuestro domicilio y seguir las indicaciones que se le entregarán en dicho momento.";
	var splitTitle3 = doc.splitTextToSize(text3, 190);
	doc.text(10, 103, splitTitle3);

	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("4° RECEPCIÓN DE CORRESPONDENCIA", 10, 125);
	doc.line(10, 126, 95, 126);
	doc.setFont("arial", "normal");
	var text3b = `El subarrendatario sólo puede recibir correspondencia a su nombre o su empresa. El tamaño de la
correspondencia a recibir no puede superar las dimensiones de un sobre tamaño oficio. De recibirse cajas,
paquetes o cualquier tipo de encomienda (tamaño máximo 50x50 cm), se considera un servicio adicional
(bodegaje) e implica cobro por tiempo de permanencia de la misma en la oficina desde que la correspondencia
es notificada ($5.000 IVA incluido por día, por bulto, que serán recargados vía factura al cliente al momento de
su retiro). Cualquier encomienda por sobre los 50x50cm no será recibida. La correspondencia recibida sólo
podrá ser retirada por las personas especificadas por el cliente al momento de firmar el contrato. De querer
agregar o eliminar a una persona o más para esta gestión debe informar vía correo electrónico a la ejecutiva o
ejecutivo encargado con copia siempre bodega@denegocios.cl.

El subarrendatario autoriza a Asesorías e Inversiones DN SpA a eliminar toda la correspondencia y documentos
recibidos a nombre de su empresa y/o de sus representantes, que no haya sido retirados en un plazo máximo de
60 días (dos meses) a partir de la notificación correspondiente. Así mismo autoriza expresamente al SUB
ARRENDADOR, tras la terminación del presente contrato por cualquiera de las causales, a eliminar toda la
correspondencia que haya quedado en la oficina respectiva.`;
	var splitTitle3b = doc.splitTextToSize(text3b, 190);
	doc.text(10, 131, splitTitle3b);

	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("5° MULTAS, GASTOS Y COSTAS", 10, 206);
	doc.line(10, 207, 75, 207);
	doc.setFont("arial", "normal");
	var text4 =`Se conviene expresamente que por el no pago oportuno de la renta convenida, el SUB ARRENDATARIO,
pagará una multa igual al interés máximo convencional para operaciones reajustables, multa que regirá desde el
día siguiente del plazo que tienen para hacerlo y hasta la fecha que se realice el pago efectivo de la obligación.
En caso de mensualidades con 30 días de atraso, se aplicará gasto de cobranza a partir del día 31 de mora, como
porcentaje de la mensualidad adeudada.

En caso de incumplimiento en el pago de las rentas convenidas, el SUB ARRENDADOR queda expresamente
facultado para informar los datos del SUB ARRENDATARIO y de su representante legal al Boletín Comercial u
otros sistemas de información comercial, previa notificación por escrito enviada al domicilio físico o correo
electrónico registrado en este contrato. El SUB ARRENDATARIO tendrá un plazo de 5 días hábiles, contados
desde la fecha de recepción de la notificación, para subsanar la deuda pendiente.

El SUB ARRENDATARIO y su representante legal aceptan y consienten expresamente que, en caso de mora o
simple retardo en el cumplimiento de sus obligaciones contractuales, sus datos personales sean tratados,
utilizados y reportados a sistemas de información comercial de acuerdo con lo establecido en la Ley N° 19.628
sobre Protección de la Vida Privada, garantizándose sus derechos de acceso, rectificación, cancelación y
oposición conforme a la normativa vigente.`;	
	var splitTitle4 = doc.splitTextToSize(text4, 190);
	doc.text(10, 212, splitTitle4);
	
	doc.addPage();
	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("6° TERMINACIÓN ANTICIPADA DEL CONTRATO", 10, 20);
	doc.line(10, 21, 110, 21);
	doc.setFont("arial", "normal");
	var text8a = `
EL SUB ARRENDADOR, podrá poner término de inmediato al presente contrato, por las siguientes causales
que las partes convienen en elevar a la calidad de esenciales o determinantes en este contrato:
	1. Si destina la oficina a cualquier otro fin que no sea el indicado en este instrumento.
	2. Si cede, subarrienda o transfiere a cualquier título el presente contrato.
	3. Si contrae compromisos económicos o legales que afecten los intereses del SUBARRENDADOR.
	4. Si causa inconvenientes a los vecinos, malos tratos con otros clientes o el personal de la oficina.
	5. Si hace mal uso de las instalaciones como de los servicios ofrecidos por el SUBARRENDADOR.
	6. Si no cancela dentro de los plazos el monto del arriendo.`;
	var splitTitle8a = doc.splitTextToSize(text8a, 190);
	doc.text(10, 25, splitTitle8a);

	doc.setFont("arial");
	doc.setFontSize(10);
	doc.text("Firmar esta Hoja", 7, 7);
	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("7° DOMICILIO", 10, 74);
	doc.line(10, 75, 40, 75);
	doc.setFont("arial", "normal");
	doc.text(
		"Para todos los efectos derivados del presente contrato, las partes fijan domicilio en la ciudad de Santiago.",
		10,
		80
	);

	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("8° EJEMPLARES DEL CONTRATO", 10, 88);
		doc.line(10, 89, 80, 89);
	doc.setFont("arial", "normal");
	var text1 =
		"El presente contrato se otorga en 2 (dos) ejemplares del mismo tenor, quedando 1 (uno) en poder del SUBARRENDADOR, y 1 (uno) en poder del SUBARRENDATARIO.";
	var splitTitle1 = doc.splitTextToSize(text1, 190);
	doc.text(10, 95, splitTitle1);

	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("9° RESPONSABILIDAD", 10, 108);
	doc.line(10, 109, 55, 109);
	doc.setFont("arial", "normal");
	var text2 =
		"Asesorias e Inversiones DN SpA no se hará cargo por multas e intereses ocasionados por falta de patente o vencimiento de ésta en el domicilio contratado.";
	var splitTitle2 = doc.splitTextToSize(text2, 190);
	doc.text(10, 115, splitTitle2);

	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("10° DATOS DE CONTACTO", 10, 128);
	doc.line(10, 129, 70, 129);
	doc.setFont("arial", "normal");
	var text3 = `Se deja en constancia que los datos de contacto del SUB ARRENDATARIO son los siguientes: Correo: ${correo}, Teléfono: ${telefono}.`;
	var splitTitle3 = doc.splitTextToSize(text3, 190);
	doc.text(10, 135, splitTitle3);

	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("11° DE LA OFICINA VIRTUAL", 10, 150);
	doc.line(10, 151, 70, 151);
	doc.setFont("arial", "normal");
	var text4 = `Sin perjuicio de lo señalado precedentemente, las partes dejan expresa constancia que el presente subarriendo se pacta exclusivamente bajo la modalidad de oficina virtual, para fines tributarios, comerciales y administrativos. En consecuencia, el subarrendatario no hará uso material ni presencial del inmueble, no atenderá público ni desarrollará actividades comerciales presenciales de ningún tipo, limitándose el subarriendo únicamente al uso del domicilio comercial y tributario. Asimismo, las partes declaran que el subarriendo no genera ocupación física, uso efectivo del inmueble ni producción de residuos, por lo que no procede el cobro de derechos municipales de aseo asociados a este contrato.`;
	var splitTitle4 = doc.splitTextToSize(text4, 190);
	doc.text(10, 155, splitTitle4);

	doc.line(10, 215, 90, 215);
	doc.text("Asesorias e Inversiones DN SpA", 10, 220);
	doc.text("77.526.796-8", 10, 225);
	doc.text("P.p Rodrigo Andres Araya Montalvan", 10, 230);
	doc.text("15.380.582-2", 10, 235);
	firmaSubarrendatario(doc, datos, 260);

	doc.addPage();
	doc.setFont("arial");
	doc.setFontSize(10);
	doc.text("Firmar esta Hoja", 10, 10);
	doc.addImage(img, "JPEG", 30, 40, 140, 160);
	doc.setFontSize(12);
	var text4 = `Yo, ${nombre} C.I. nro. ${rut}, autorizo al Sr. Notario don JUAN RICARDO SAN MARTIN URREJOLA, para que autorice mi firma en el Contrato de SubArriendo, celebrado con fecha de hoy ${fecha}.`;
	var splitTitle4 = doc.splitTextToSize(text4, 190);
	doc.text(10, 220, splitTitle4);
	doc.line(65, 244, 135, 244);
	doc.text("Firma", 100, 250, { align: "center" });

	doc.save(`Contrato Arriendo Providencia Provisorio para ${nombreParaArchivo(datos)}.pdf`);
};
